<template>
  <div class="search-filter-header">
    <div class="row">
      <div class="col-8 d-flex align-items-center">
        <div class="multiple-options-selection">
          <div
            class="handler d-flex align-items-center justify-content-between form-control"
            @click.stop="toggleFilterMenu"
          >
            <div class="selected-option-count" v-if="false">
              {{ filter_options.filter((each) => each.selected).length }}
            </div>
            <div class="place-holder">
              {{ filter_options?.find((each) => each.selected)?.label }}
            </div>
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{ transform: open_filter_menu ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div
            v-if="open_filter_menu"
            v-click-outside="toggleFilterMenu"
            class="options p-3"
            :style="isLangRtl ? 'right: 0px; width: 220px' : 'left: 0px; width: 220px'"
          >
            <div
              v-if="false"
              class="option d-flex align-items-center cursor-pointer mb-2 pb-2"
              @click="selectAllFilterOption"
            >
              <input type="checkbox" name="all" :checked="select_all" />
              <div class="ms-2">
                {{ $t('all') }}
              </div>
            </div>
            <div
              v-for="(option, index) in filter_options"
              :key="index"
              :class="
                index < filter_options.length - 1
                  ? 'option d-flex align-items-center cursor-pointer mb-2 pb-2'
                  : 'cursor-pointer'
              "
              @click="selectSingleFilterOption(option)"
            >
              <input
                v-if="false"
                type="checkbox"
                :name="option.key"
                :checked="option.selected"
                class="me-2"
              />
              <div>
                {{ option?.label }}
              </div>
            </div>
            <div
              v-if="false"
              class="d-flex align-items-center cursor-pointer mt-2"
              @click="resetFilterSelection"
            >
              <img
                :src="require('@/assets/images/icons/trash-icon.svg')"
                alt="delete image"
                class="me-2"
              />
              <div>
                {{ $t('reset-selection') }}
              </div>
            </div>
          </div>
        </div>
        <div class="mx-2">
          <base-input
            cus_style="width:300px"
            :remove_default_margin="true"
            id="vehicle-list-search-text"
            placeholder="search-here"
            field="search_text"
            :value="search_text"
            :type="filter_options?.find((each) => each.selected)?.type"
            @change-value="setValue"
            @enter="search"
          />
        </div>
        <div>
          <base-button variant="primary" id="vehicle-list-search-btn" @click="search">
            {{ $t('search') }}
          </base-button>
        </div>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-end">
        <div class="me-2">
          <base-button
            id="InsuranceCompany-add-btn"
            cus_style="padding:8px 20px"
            variant="secondary"
            :class="['add-btn py-2 px-4']"
            @mouseenter="ExportBtnHovered = true"
            @mouseleave="ExportBtnHovered = false"
            :loading="loading"
            @click="download"
            :disabled="totalRows === 0"
          >
            {{ $t('export') }}
            <img class="export-icon ms-2" src="@/assets/images/icons/export-icon.svg" />
          </base-button>
        </div>
        <div class="me-2">
          <base-button
            cus_style="padding:8px 20px"
            variant="secondary"
            :class="[
              'add-btn py-2 px-4',
              {
                'not-allowed': this.$store.getters['enums/is_not_permitted']('addVehicle'),
              },
            ]"
            @mouseenter="AddBtnHovered = true"
            @mouseleave="AddBtnHovered = false"
            @click="MoveToAddVehicle"
          >
            <img
              :src="
                AddBtnHovered
                  ? require(`@/assets/images/icons/add-icon.svg`)
                  : require(`@/assets/images/icons/add-icon.svg`)
              "
              alt="plus icon"
            />
            <div class="mx-2">{{ $t('add-vehicle') }}</div>
          </base-button>
        </div>
      </div>
    </div>
    <b-alert :show="error && error.length" variant="danger" class="mt-2">
      <div v-if="Array.isArray(error)">
        <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <hr />
    <div class="row align-items-center">
      <div class="col-8 totals-row">
        <h5 class="result">
          {{ $t('total') }}: <span class="totals-number">{{ totalRows }}</span>
        </h5>
        <h5 class="result">
          {{ $t('available-vehicles') }}: <span class="totals-number">{{ AvailableLengths }}</span>
        </h5>
      </div>
      <div class="col-4 d-flex align-items-center justify-content-end">
        <div v-if="selected_view === 'table'" class="me-2">
          {{ $t('group-by') }}
        </div>
        <div v-if="selected_view === 'table'" class="me-2 multiple-options-selection">
          <div
            class="handler d-flex align-items-center justify-content-between form-control"
            @click.stop="toggleGroupByMenu"
          >
            <div class="place-holder">
              {{ group_by_options?.find((each) => each.selected)?.label }}
            </div>
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{ transform: open_group_by_menu ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div
            v-if="open_group_by_menu"
            v-click-outside="toggleGroupByMenu"
            class="options p-3"
            :style="isLangRtl ? 'left: 0px; width: 180px' : 'right: 0px; width: 180px'"
          >
            <div
              v-for="(option, index) in group_by_options"
              :key="index"
              :class="
                index < group_by_options.length - 1
                  ? 'option cursor-pointer mb-2 pb-2'
                  : 'cursor-pointer'
              "
              @click="selectGroupByOption(option)"
            >
              <b v-if="option?.selected">
                {{ option?.label }}
              </b>
              <span v-else>{{ option?.label }}</span>
            </div>
          </div>
        </div>
        <div>
          <base-button
            id="vehicles_filter_btn"
            variant="secondary"
            class="filter__btn"
            v-b-toggle.sidebar-backdrop
            @mouseenter="filterBtnHovered = true"
            @mouseleave="filterBtnHovered = false"
          >
            <img
              :src="
                filterBtnHovered
                  ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
                  : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
              "
              alt="filter"
            />
          </base-button>
        </div>
        <div
          v-if="selected_view === 'table'"
          style="position: relative"
          class="ms-2 multiple-options-selection"
        >
          <base-button
            id="vehicles_filter_btn"
            variant="secondary"
            class="filter__btn"
            @click="toggleFormBuilder"
          >
            <img
              :src="require(`@/assets/images/icons/form-builder.svg`)"
              alt="form-builder"
              height="16px"
            />
          </base-button>
          <div
            v-if="open_form_builder"
            v-click-outside="toggleFormBuilder"
            class="options p-3"
            :style="isLangRtl ? 'left: 0px; width: 220px' : 'right: 0px; width: 220px'"
          >
            <div
              v-for="(option, index) in localFields"
              :key="index"
              class="option d-flex align-items-center cursor-pointer mb-2 pb-2"
              @click="selectField(option)"
            >
              <input
                type="checkbox"
                :name="option.key"
                :checked="option.selected"
                :disabled="
                  localFields.filter((each) => each.selected).length === 1 && option.selected
                "
                class="me-2"
              />
              <div>
                {{ option?.label }}
              </div>
            </div>
            <div class="d-flex align-items-center cursor-pointer mt-2" @click="resetFieldSelection">
              <img
                :src="require('@/assets/images/icons/trash-icon.svg')"
                alt="delete image"
                class="me-2"
              />
              <div>
                {{ $t('reset-selection') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fields', 'totalRows', 'selected_view', 'AvailableLengths'],
  emits: ['quickSearch', 'selectField', 'resetFieldSelection', 'selectView', 'groupByKey'],
  data() {
    return {
      defaultFields: [],
      localFields: [],
      error: null,
      variant: 'transparent',
      ExportBtnHovered: false,
      loading: false,
      AddBtnHovered: false,
      filterBtnHovered: false,
      open_filter_menu: false,
      open_group_by_menu: false,
      search_text: null,
      select_all: false,
      filter_options: [
        {
          key: 'operationalID',
          label: this.$t('operational-id'),
          selected: true,
          type: 'number',
        },
        {
          key: 'tgaNumber',
          label: this.$t('tga-number'),
          selected: false,
          type: 'text',
        },
        {
          key: 'plateNumber',
          label: this.$t('plate-number'),
          selected: false,
          type: 'text',
        },
        {
          key: 'chassisNumber',
          label: this.$t('chassis-number'),
          selected: false,
          type: 'text',
        },
      ],
      group_by_options: [
        {
          key: 'none',
          label: this.$t('none'),
          selected: true,
        },
        {
          key: 'branch',
          label: this.$t('branch'),
          selected: false,
        },
        {
          key: 'provider',
          label: this.$t('provider'),
          selected: false,
        },
        {
          key: 'category',
          label: this.$t('vehicle-category'),
          selected: false,
        },
        {
          selected: false,
          label: this.$t('brand'),
          key: 'brand',
        },
        {
          selected: false,
          label: this.$t('model'),
          key: 'model',
        },
        {
          selected: false,
          label: this.$t('year-of-making'),
          key: 'makeYear',
        },
        {
          key: 'numberOfSeats',
          label: this.$t('number-of-seat'),
          selected: false,
        },
      ],
      open_form_builder: false,
    }
  },
  methods: {
    download() {
      this.$emit('download')
    },
    toggleFormBuilder() {
      this.open_filter_menu = false
      this.open_group_by_menu = false
      this.open_form_builder = !this.open_form_builder
    },
    MoveToAddVehicle() {
      if (!this.$store.getters['enums/is_not_permitted']('addVehicle'))
        this.$router.push('/vehicle/add').catch(() => {})
    },
    selectAllFilterOption() {
      this.select_all = !this.select_all
      this.filter_options = this.filter_options?.map((each) => {
        each['selected'] = this.select_all
        return each
      })
    },
    selectSingleFilterOption(option) {
      this.toggleFilterMenu()
      this.search_text = null
      this.filter_options = this.filter_options?.map((each) => {
        if (option.key === each.key) each['selected'] = true
        else each['selected'] = false
        return each
      })
    },
    resetFilterSelection() {
      this.search_text = null
      this.filter_options = this.filter_options?.map((each) => {
        each['selected'] = false
        return each
      })
    },
    setValue(val, field) {
      this[field] = val
    },
    search() {
      if (this.filter_options?.find((each) => each.selected)?.key === 'operationalID')
        this.$emit(
          'quickSearch',
          this.filter_options?.find((each) => each.selected)?.key,
          Number(this.search_text)
        )
      else {
        this.$emit(
          'quickSearch',
          this.filter_options?.find((each) => each.selected)?.key,
          this.search_text
        )
      }
    },
    toggleFilterMenu() {
      this.open_filter_menu = !this.open_filter_menu
      this.open_group_by_menu = false
      this.open_form_builder = false
    },
    toggleGroupByMenu() {
      this.open_filter_menu = false
      this.open_group_by_menu = !this.open_group_by_menu
      this.open_form_builder = false
    },
    selectGroupByOption(option) {
      this.toggleGroupByMenu()
      this.group_by_options = this.group_by_options?.map((each) => {
        if (option.key === each.key) each['selected'] = true
        else each['selected'] = false
        return each
      })
      this.$emit('groupByKey', this.group_by_options?.find((each) => each.selected)?.key)
    },
    selectField(option) {
      const selectedCount = this.localFields.filter((each) => each.selected).length

      this.localFields = this.localFields.map((field) => {
        if (field.key === option.key) {
          if (selectedCount === 1 && field.selected) {
            return field
          }

          return {
            ...field,
            selected: !field.selected,
          }
        }

        return field
      })

      this.$emit('update:fields', JSON.parse(JSON.stringify(this.localFields)))

      this.$emit('selectField', option)

      localStorage.setItem('vehicle_table_columns', JSON.stringify(this.localFields))
    },
    resetFieldSelection() {
      this.localFields = JSON.parse(JSON.stringify(this.defaultFields))

      localStorage.removeItem('vehicle_table_columns')

      this.$emit('update:fields', JSON.parse(JSON.stringify(this.localFields)))

      this.$emit('resetFieldSelection', JSON.parse(JSON.stringify(this.localFields)))
    },
  },
  watch: {
    filter_options(val) {
      if (val?.find((each) => !each.selected)) this.select_all = false
      else this.select_all = true
    },

    fields: {
      handler(val) {
        this.localFields = JSON.parse(JSON.stringify(val))
      },
      deep: true,
    },
  },
  created() {
    this.defaultFields = JSON.parse(JSON.stringify(this.fields))
    this.localFields = JSON.parse(JSON.stringify(this.fields))
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/vehicles.json'),
      ar: require('@/services/i18n/locales/ar/vehicles.json'),
    },
  },
}
</script>

<style scoped lang="scss">
.totals-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.totals-number {
  color: var(--color-02);
}
</style>

<style lang="scss">
.search-filter-header {
  .search-input-field {
    font-size: 14px;
    letter-spacing: -0.006em;
    color: var(--color-03);
    max-height: 40px;
  }

  .searchOption {
    select {
      background: transparent;
    }
  }
}
</style>
